const formateQTY=(qty=0)=>{
    if(qty>0){
        return parseFloat(qty.toFixed(1)).toLocaleString()
    }else{
        return parseFloat(qty.toFixed(6)).toLocaleString()
    }
}
export default formateQTY;